"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
var Bootstrap = (function () {
    function Bootstrap() {
        this.helpers = new helpers_1.default();
    }
    Bootstrap.prototype.init = function () {
        this.helpers.setRequestAnimationFrame();
    };
    return Bootstrap;
}());
exports.default = Bootstrap;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/coin-animation/index.ts
// module id = 2009
// module chunks = 4